import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Checkbox } from 'primereact/checkbox';
import 'primeicons/primeicons.css';
import Alertas from "../../alertas";

function DadosMulher({ setFraseTopo, setStage, nome, dataNasc, cpf, telefone, concorda_telefone, email, concorda_email, cepCasa, ruaCasa, numeroCasa, compCasa, file_rg, setNome, setDataNasc, setCpf, setTelefone, setConcordaTelefone, setEmail, setConcordaEmail, setCepCasa, setRuaCasa, setNumeroCasa, setCompCasa, setFile_rg }) {


    const changeFiles = (file) => {
        const maxSize = 3 * 1024 * 1024; // 3 MB em bytes                                                           
        if (file.size > maxSize) {
            Alertas.atencao('Tamanho não permitido. Por favor escolha um arquivo de no máximo 3 MB.');
        } else {
            setFile_rg(file);
        }
    };

    function verificacao(step) {
        if (cpf && nome && dataNasc && cepCasa && ruaCasa && numeroCasa && telefone && email) {
            setStage(step)
        } else {
            Alertas.atencao('Preencha os campos obrigatórios (*).');
        }
    }


    useEffect(() => {
        setFraseTopo("Sua coragem é o primeiro passo para a liberdade.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="app-main-mulher">
            <div className="main-card-mulher" style={{ padding: "0px" }}>
                <div className="header-solicitacao-mulher">
                    <h3>SOLICITAÇÃO DE MEDIDA PROTETIVA</h3>
                </div>
                <p className="descr-solicitacao-mulher">O Núcleo Institucional de Promoção e Defesa dos Direitos  da Mulher irá entrar em contato para dar início ao seu atendimento.</p>
            </div>

            <h3 className="main-titulo-mulher">DADOS DA MULHER</h3>
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div className="card-form-b">
                        <p className="labels">CPF <span className='pink'>*</span></p>
                        <InputMask mask="999.999.999-99" value={cpf} onChange={(e) => setCpf(e.target.value)} />
                    </div>
                    <div className="card-form-a">
                        <p className="labels">Nome Completo <span className='pink'>*</span></p>
                        <InputText value={nome} onChange={(e) => setNome(e.target.value)} />
                    </div>
                    <div className="card-form-b">
                        <p className="labels">Data de Nascimento <span className='pink'>*</span></p>
                        <InputMask mask="99/99/9999" value={dataNasc} onChange={(e) => setDataNasc(e.target.value)} />
                    </div>
                </div>
                <div className="card-form card-form-mulher">
                    <div className="card-form-b">
                        <p className="labels">CEP  <span className='pink'>*</span></p>
                        <InputText value={cepCasa} onChange={(e) => setCepCasa(e.target.value)} />
                    </div>
                    <div className="card-form-a">
                        <p className="labels">Rua  <span className='pink'>*</span></p>
                        <InputText value={ruaCasa} onChange={(e) => setRuaCasa(e.target.value)} />
                    </div>
                    <div className="card-form-b">
                        <p className="labels">Número  <span className='pink'>*</span></p>
                        <InputText value={numeroCasa} onChange={(e) => setNumeroCasa(e.target.value)} />
                    </div>
                    <div className="card-form-a">
                        <p className="labels">Complemento </p>
                        <InputText value={compCasa} onChange={(e) => setCompCasa(e.target.value)} />
                    </div>
                </div>
            </div>

            <h3 className="main-titulo-mulher">INFORMAÇÕES DE CONTATO</h3>
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div className="card-form-a">
                        <p className="labels">Telefone  <span className='pink'>*</span></p>
                        <InputMask mask="(99) 99999-9999" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
                    </div>


                    <div className="card-form-a">
                        <p className="labels">Email  <span className='pink'>*</span></p>
                        <InputText value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>

                </div>
                <div className="card-form card-form-mulher">
                    <div className="card-form-a item-check-mulher" style={{marginTop:"10px"}}>
                        <Checkbox onChange={e => setConcordaTelefone(e.checked)} checked={concorda_telefone} />
                        <label > Concordo com notificação via whatsapp </label>
                    </div>

                    <div className=" card-form-a item-check-mulher" style={{marginTop:"10px"}}>
                        <Checkbox onChange={e => setConcordaEmail(e.checked)} checked={concorda_email} />
                        <label > Concordo com notificação via e-mail </label>
                    </div>
                </div>
            </div>

            <h3 className="main-titulo-mulher">DOCUMENTO OFICIAL COM FOTO</h3>
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <span className='input-arquivo-mulher'>
                        <label className='label-file'
                            style={file_rg ? { backgroundColor: "#30053F" } : { backgroundColor: "#571070" }}
                        >
                            {file_rg ?
                                <span className='file-name'> <i className="pi pi-image" ></i>{" "} {file_rg.name} </span>
                                :
                                <span className='file-name'>Nenhum arquivo selecionado<i className="pi pi-upload"></i>{" "}</span>
                            }
                            <input
                                type="file"
                                className='input-files'
                                accept='image/*'
                                onChange={e => changeFiles(e.target.files[0])}
                            />
                        </label>
                    </span>
                </div>
            </div>
            <div className="card-rodape-mulher">
                <Button
                    label="Próximo"
                    className="btn-1-mulher"
                    onClick={() => verificacao(2)}
                />
            </div>
        </div>

    );
}

export default DadosMulher;
